// extracted by mini-css-extract-plugin
export default {"label":"FormInput_label__N5i4A"};